// Todo: Need to confirm with product, these are the current values used in reports

export const chartEmptyValueConstants = {
  job_name: 'No job name',
  primary_recruiter: 'No primary recruiter',
  primary_hm: 'No primary hiring manager',
  appl_source: 'No source',
  department: 'No department',
  root_department: 'No department',
  appl_location: 'No location',
  rejection_type: 'No rejection type',
  rejection_reason: 'No rejection reason',
  gender: 'Unknown',
  appl_credited_to: 'Not credited',
  job_location: 'No location',
  appl_contact_source: 'No source',
  rejected_by: 'No rejected by',
  rejected_stage: 'Unknown',
  rejected_milestone: 'No stage',
  contact_source: 'No source',
  contact_credited_to: 'Not credited',
  contact_location: 'No location',
  experience_bucket: 'Unknown',
  interview_location: 'No location',
  rejected_by_type: 'AI',
  office: 'No office',
  hiring_manager: 'No hiring manager',
  recruiter: 'No recruiter',
  action_performed_by_user: 'No action performed by user',
  bgv_risk_level: 'Not evaluated',
};
